import React from "react";

export default function AboutUs() {
  return (
    <div>
      <div style={{ backgroundColor: "#050810" }} className="p-3 mt-3">
        <div
          className="d-flex "
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            className="header mb-0"
            style={{
              fontFamily: "NunitoBlack",

              color: "white",
            }}
          >
            About Us
          </p>
        </div>
        <div
          className="d-flex"
          style={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <p
            className="sub-header"
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
            }}
          >
            We Are Game Changers
          </p>
        </div>
        <div className="container">
          <p
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
              //   fontSize: "15px",
              textAlign: "center",
            }}
            className="mt-3 fs-5"
          >
            <b>
              Welcome to WolfWin, where gaming dreams become an opportunity. Our
              mission is simple: to provide you with thrilling gameplay, the
              chance to showcase your skills, and the opportunity to win
              remarkable Rewards. We are a passionate team dedicated to
              creating unforgettable experiences in the world of skill-based
              games. What sets us apart is our unwavering commitment to
              fairness, transparency, and innovation. We have created a level
              playing field where your success is solely determined by your
              skill and strategy.
            </b>
          </p>
          <p
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
              //   fontSize: "15px",
              textAlign: "center",
            }}
            className="mt-3 fs-5"
          >
            <b>
              Join us at WolfWin and embark on an extraordinary adventure where
              your skills are rewarded, your achievements are celebrated, and
              unforgettable memories are made. Get ready to experience the
              thrill of victory, the joy of competition, and the satisfaction of
              being part of a gaming revolution.
            </b>
          </p>
          {/* <p
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
              //   fontSize: "15px",
              textAlign: "center",
            }}
            className="mt-3 fs-5"
          >
            <b>
              What sets us apart is our unwavering commitment to fairness,
              transparency, and innovation. We have created a level playing
              field where your success is solely determined by your skill and
              strategy. With cutting-edge technology and advanced game
              mechanics, we ensure that every gameplay experience is seamless,
              immersive, and filled with excitement.
            </b>
          </p>
          <p
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
              //   fontSize: "15px",
              textAlign: "center",
            }}
            className="mt-3 fs-5"
          >
            <b>
              But WolfWin is more than just a gaming platform. We are a
              community of like-minded individuals who share a passion for
              competition, growth, and the pursuit of excellence. Connect with
              fellow players, challenge friends or make new ones, and engage in
              friendly rivalries that will fuel your gaming journey.
            </b>
          </p>
          <p
            style={{
              color: "#929498",
              fontFamily: "JosefinSans",
              //   fontSize: "15px",
              textAlign: "center",
            }}
            className="mt-3 fs-5"
          >
            <b>
              Join us at WolfWin and embark on an extraordinary adventure where
              your skills are rewarded, your achievements are celebrated, and
              unforgettable memories are made. Get ready to experience the
              thrill of victory, the joy of competition, and the satisfaction of
              being part of a gaming revolution.
            </b>
          </p> */}
        </div>
      </div>
    </div>
  );
}
